import React, { useEffect, useState } from 'react';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { startNewFunctionalSkillSession } from '../../../modules/functional_skills_api';
import { getPlayerByInsightsId } from '../../../modules/player_api';

interface MatchParams {
  playerId: string;
  functionalSkillId: string;
  gameId: string;
}

const InterventionLaunch: React.FC<RouteComponentProps<MatchParams>> = ({ match }) => {
  const { playerId, functionalSkillId, gameId } = match.params;
  const [sessionId, setSessionId] = useState(-1);
  const [restorePlayerId, setRestorePlayerId] = useState(-1);

  const setup = async () => {
    const playerResponse = await getPlayerByInsightsId(playerId);

    let parsedPlayerId = -1;
    if (playerResponse?.data && playerResponse.data?.id) {
      parsedPlayerId = playerResponse.data.id;
      await setRestorePlayerId(parsedPlayerId);
    }
    const newFunctionalSkillSessionResponse = await startNewFunctionalSkillSession(functionalSkillId, parsedPlayerId);

    if (newFunctionalSkillSessionResponse?.data && newFunctionalSkillSessionResponse.data.success) {
      await setSessionId(newFunctionalSkillSessionResponse.data.new_functional_skill_session_id);
    }
  };

  useEffect(() => {
    setup();
  }, []);

  return (
    <div>
      {sessionId !== -1 && restorePlayerId !== -1 && (
        <Redirect
          push
          to={{
            pathname: `/play/insights/intervention/${sessionId}/${restorePlayerId}/${gameId}`,
            state: { from: location.pathname },
          }}
        />
      )}
    </div>
  );
};

export default InterventionLaunch;
